/**
 * Engage dialog host for shadow profile comparison (ITT-970).
 */

import PropTypes from 'prop-types';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import BeerProfileShadowComparisonPanel from './BeerProfileShadowComparisonPanel';

function BeerProfileShadowComparisonDialog({ open, beerId, beerName, onClose }) {
  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
      <DialogTitle>Shadow profile</DialogTitle>
      <DialogContent dividers>
        {beerId ? (
          <BeerProfileShadowComparisonPanel beerId={beerId} beerName={beerName} />
        ) : null}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Close</Button>
      </DialogActions>
    </Dialog>
  );
}

BeerProfileShadowComparisonDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  beerId: PropTypes.string,
  beerName: PropTypes.string,
  onClose: PropTypes.func.isRequired,
};

BeerProfileShadowComparisonDialog.defaultProps = {
  beerId: null,
  beerName: null,
};

export default BeerProfileShadowComparisonDialog;
